import { render } from "./App.vue?vue&type=template&id=0881f4a8&lang=pug&bindings={}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=sass"
script.render = render

export default script